import { Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';

interface EllipseInterface {
	message: string;
	maxLength: number | string;
	isTooltip?: boolean;
	tooltipMessage?: string;
	isLink?: boolean;
}

const Ellipse = (props: EllipseInterface) => {
	const {
		message,
		isTooltip,
		tooltipMessage,
		isLink,
		maxLength = 40,
	} = props;

	const [truncatedText, setTruncatedText] = useState(message);
	const textRef = useRef<any>(null);

	useEffect(() => {
		if (message?.length > Number(maxLength)) {
			setTruncatedText(message.substring(0, Number(maxLength)) + '...');
		} else {
			setTruncatedText(message);
		}
	}, [message, maxLength]);

	const scrollableTooltip = (
		<div
			style={{
				maxHeight: '200px',
				overflowY: 'auto',
				whiteSpace: 'pre-wrap',
			}}
		>
			{tooltipMessage || message}
		</div>
	);

	return (
		<div
			className={styles['ellipse-container']}
			ref={textRef}
			style={{
				cursor: isLink ? 'pointer' : 'auto',
				color: isLink ? '#007bff' : 'inherit',
			}}
		>
			{isTooltip ? (
				<Tooltip title={scrollableTooltip}>
					<span>{truncatedText}</span>
				</Tooltip>
			) : (
				<span>{truncatedText}</span>
			)}
		</div>
	);
};

export default Ellipse;
